import { useEffect, useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import { LuxAccordion } from '@lux/wardrobe-lib'
import ReferenceInput from '../UI/ReferenceInput/ReferenceInput'
import DialogSelectFolder from '../UI/Dialogs/DialogSelectFolder/DialogSelectFolder'
import './ForumReferenceThread.scss'
import { ResourceProps, ResourceType } from '@/app/models/new-resource'
import { ForumService } from '@/app/services/ForumService'
import { getThreadTree } from '@/app/utils/forumAdapter'
import { Thread } from '@/app/models/forum/new-forum.model'

export interface ForumReferenceThread {
    referenceTitle?: string
    referenceId?: string
    onSetReference: (value: Thread) => void
}

const ForumReferenceThread = ({
    referenceId,
    referenceTitle,
    onSetReference,
}: ForumReferenceThread) => {
    const intl = useIntl()
    const [dialogSelectThreadVisible, setDialogSelectThreadVisible] = useState(false)
    const [referenceThread, setReferenceThread] = useState<any>(null)
    const [referenceThreadList, setReferenceThreadList] = useState<ResourceProps[]>([])
    const [loading, setLoading] = useState(false)
    const accordionTitle = useMemo(
        () =>
            intl.formatMessage({
                id: 'modals.new.forum.reference.thread.title',
                defaultMessage: 'Reference Thread',
            }),
        [intl]
    )
    const placeholder = useMemo(
        () =>
            referenceTitle ||
            intl.formatMessage({
                id: 'modals.new.forum.reference.thread.placeholder',
                defaultMessage: 'Select the reference thread',
            }),
        [intl, referenceTitle]
    )
    const dialogTitle = useMemo(
        () =>
            intl.formatMessage({
                id: 'modals.new.forum.reference.thread.dialog.title',
                defaultMessage: 'Select thread',
            }),
        [intl]
    )
    const dialogDescription = useMemo(
        () =>
            intl.formatMessage({
                id: 'modals.new.forum.reference.thread.dialog.description',
                defaultMessage: 'Select the reference thread',
            }),
        [intl]
    )

    useEffect(() => {
        setReferenceThread({
            _id: referenceId,
            title: referenceTitle,
        })
    }, [referenceId, referenceTitle])

    const onChange = () => {
        setLoading(true)
        setDialogSelectThreadVisible(true)
        ForumService.GetThreadList({})
            .then((res) => {
                if (res && res.data && !res.data.output) {
                    setReferenceThreadList(getThreadTree(res.data.data))
                }
            })
            .finally(() => setLoading(false))
    }
    const onHide = () => setDialogSelectThreadVisible(false)
    const onSave = () => {
        onSetReference(referenceThread)
        setDialogSelectThreadVisible(false)
    }
    const onSetSelectedFolderId = (id: string) => {
        const thread = referenceThreadList.find((t) => t._id === id)
        setReferenceThread(thread)
        // setReferenceTitle(thread?.title)
    }

    return (
        <>
            <LuxAccordion title={accordionTitle}>
                <div className="smart-modals-forum-reference-thread-input">
                    <ReferenceInput
                        placeholder={placeholder}
                        icon="folder-bullets"
                        onChange={onChange}
                    />
                </div>
                {dialogSelectThreadVisible && (
                    <DialogSelectFolder
                        visible={dialogSelectThreadVisible}
                        title={dialogTitle}
                        description={dialogDescription}
                        loading={loading}
                        folders={referenceThreadList}
                        selectedFolderId={referenceThread?._id}
                        resourceType={ResourceType.subfolder}
                        onSave={onSave}
                        onHide={onHide}
                        setSelectedFolderId={onSetSelectedFolderId}
                    />
                )}
            </LuxAccordion>
        </>
    )
}

export default ForumReferenceThread
